import { Text } from 'bold-ui'
import { useExisteProblemaResolvidoQuery, useProblemasCardQuery } from 'graphql/hooks.generated'
import { SituacaoProblema } from 'graphql/types.generated'
import React from 'react'

import { ProblemaCondicaoModel } from '../../avaliacao/components/problemas-condicoes/model'
import { AccordionCardSection } from '../components/AccordionCardSection'
import { ContentCardSection } from '../components/ContentCardSection'
import { ProblemasListCard } from './components/ProblemasListCard'
import formatProblemas from './formatProblemas'

export interface ProblemasCardProps {
  prontuarioId: ID
  problemasAvaliados: ProblemaCondicaoModel[]
}

export function ProblemasCard(props: ProblemasCardProps) {
  const { prontuarioId, problemasAvaliados } = props

  const { data, loading } = useProblemasCardQuery({
    variables: {
      filtro: {
        prontuarioId,
        situacoes: [SituacaoProblema.ATIVO, SituacaoProblema.LATENTE],
      },
    },
  })

  const todosProblemas = formatProblemas(data?.problemas?.content || [], problemasAvaliados)
  const problemasExpandido = todosProblemas.getProblemasExpandido()
  const problemasAccordion = todosProblemas.getProblemasAccordion()
  const problemaResolvido = useExisteProblemaResolvidoQuery({
    variables: {
      prontuarioId,
    },
  })

  return (
    <>
      <ContentCardSection isLoading={loading} messageLoading='Carregando dados dos problemas'>
        <ProblemasListCard problemas={problemasExpandido} />
        {problemasExpandido.length === 0 &&
          (problemaResolvido.data.existeProblemaResolvido ? (
            <Text component='p'>Ver problemas/condições resolvidos.</Text>
          ) : (
            <Text component='p'>Nenhum problema/condição registrado.</Text>
          ))}
      </ContentCardSection>

      {problemasAccordion.length > 0 && (
        <AccordionCardSection
          id='ProblemasCard'
          title={{
            closed: `Mostrar + ${problemasAccordion.length} problemas`,
            open: `Esconder problemas`,
          }}
        >
          <ProblemasListCard problemas={problemasAccordion} />
        </AccordionCardSection>
      )}
    </>
  )
}
